export default "/images/select_opt2_ad_creative_dark.gif?6a525a8764ca2b2c7d050d1707ff6f87";